import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import NavBar from "../components/NavBar";
import PassportVisaDetails from "../components/PassportVisaDetails";

const PassportVisa = () => {
  return (
    <>
      {/* Navigation Bar */}
      <NavBar />

      {/* Navigation Bar */}
      <Breadcrumb title={"Passport & Visa Assistance"} />

      {/* Service Details Area */}
      <PassportVisaDetails />

      {/* Footer One */}
      <FooterOne />
    </>
  );
};

export default PassportVisa;

